import { useTranslation } from "react-i18next";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { CheckCircleFilled } from "@ant-design/icons";
import { Flex } from "antd";
import { createStyles } from "antd-style";

import { ATS_PUBLIC_APP_PATH } from "@av/apps/recruitment/ats-common/routes/jobs/jobs.route-config";
import { QUERY_PARAMS } from "@av/apps/recruitment/ats-common/routes/jobs/query-params";
import { Button } from "@av/components/atoms/Button";
import { Typography } from "@av/components/atoms/typography/Typography";
import { isSupportedLocale } from "@av/components/organisms/editor/localized-text-editor/text-editor-supported-locales";

const useStyles = createStyles(({ css, token }) => ({
  page: css`
    justify-content: center;
    padding: ${token.paddingXL * 2}px ${token.paddingXL * 3}px;
    max-width: 1040px;
    max-height: 394px;
    background: ${token.colorTextLightSolid};
  `,
  icon: css`
    font-size: ${token.fontSizeHeading1 * 2}px;
    color: ${token.colorSuccess};
    margin-bottom: ${token.marginLG}px;
  `,
  buttonRow: css`
    margin-top: ${token.marginXL}px;
  `,
  backLink: css`
    color: ${token.colorPrimary};
    padding-right: ${token.paddingLG}px;
  `,
}));

export function ApplicationSubmitted() {
  const { styles } = useStyles();
  const { Text, Title } = Typography;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const locale = searchParams.get(QUERY_PARAMS.locale);
  const localeSearch =
    locale && isSupportedLocale(locale) ? `?${QUERY_PARAMS.locale}=${locale}` : "";

  const testIdPrefix = "application-submitted";

  return (
    <Flex className={styles.page}>
      <Flex vertical align="center" style={{ width: "60%", textAlign: "center" }}>
        <CheckCircleFilled className={styles.icon} data-testid={`${testIdPrefix}-icon`} />
        <Title level={3} testIdPrefix={`${testIdPrefix}-title`}>
          {t("recruitment.applicationSubmitted.title")}
        </Title>
        <Text testIdPrefix={`${testIdPrefix}-description`}>
          {t("recruitment.applicationSubmitted.message")}
        </Text>
        <Flex gap={16} className={styles.buttonRow} wrap justify="center" align="center">
          <Button
            type="link"
            className={styles.backLink}
            onClick={() => {
              navigate({
                pathname: `/${ATS_PUBLIC_APP_PATH}/${companyId}`,
                search: localeSearch,
              });
            }}
            testIdPrefix={`${testIdPrefix}-back-to-jobs`}
          >
            <Text testIdPrefix={`${testIdPrefix}-back-to-jobs`} className={styles.backLink}>
              {t("recruitment.applicationSubmitted.backToJobs")}
            </Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}
